import onboarding from './onboarding';

export default {
    ...onboarding,
};
